import React, { useState } from 'react';

import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneSound from 'components/dropzoneUpload/DropZoneSound';
import { Form } from 'antd';
import SmallModal from 'components/form/SmallModal';
import SubmitButton from 'components/button/SubmitButton';
import VerticalForm from 'components/form/DefaultForm';
import { platformSoundRegister } from 'apis/operation/platformSoundApis';

/**
 *
 * @returns {플랫폼 사운드 신규 등록 모달}
 */
const PlatformSoundRegisterModal = ({
  visible,
  setVisible,
  fetchData,
  optionList,
  selectSoundType,
  setSelectSoundType,
}) => {
  const [inputDatas, setInputDatas] = useState({
    sound_name: '',
    sound_type: 'se',
  });
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const handleClose = () => {
    setVisible(false);
    setInputDatas({ ...inputDatas, sound_name: '', sound_type: 'se' });
    form.resetFields();
    setFile('');
  };

  /// 사운드 타입 드롭다운
  const handleChangeSoundType = (value) => {
    setSelectSoundType(value);
  };

  /// 사운드명 입력
  const handleInputName = (e) => {
    setInputDatas({ ...inputDatas, sound_name: e.target.value });
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    formData.append('sound_name', inputDatas.sound_name);
    formData.append('sound_type', inputDatas.sound_type);
    // const res = await platformSoundRegister(formData);
    setVisible(false);
    setFile(null);
    setInputDatas({ ...inputDatas, sound_name: '', sound_type: 'se' });
    form.resetFields(); // 드롭존 이미지를 비우기 위해 필요하다.
    fetchData();
  };
  return (
    <SmallModal
      title='플랫폼 사운드 등록'
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm form={form} drop>
        <Form.Item label='사운드 타입'>
          <DefaultSelect
            optionList={optionList}
            value={inputDatas.sound_type}
            onChange={handleChangeSoundType}
          />
        </Form.Item>
        <Form.Item label='사운드 이름'>
          <DefaultInput
            value={inputDatas.sound_name}
            onChange={handleInputName}
          />
        </Form.Item>
        <Form.Item name='uploadFile'>
          <DropZoneSound setFile={setFile} />
        </Form.Item>
        <SubmitButton onClick={handleSubmit}>등록하기</SubmitButton>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformSoundRegisterModal;
